<template>
  <div>
    <div id="map-container"></div>
    <!-- <b-form-checkbox
      id="checkbox-1"
      @change="onSelectEntireUS"
      v-model="status"
      name="checkbox-1"
      value="accepted"
      unchecked-value="not_accepted"
    >
      Entire US Region
    </b-form-checkbox> -->
  </div>
</template>

<script>
import Highcharts from 'highcharts';
import json from '../assets/data/usmap.json';

var map;

export default {
  name: 'MapModal',
  props: ['region', 'regionId'],
  data() {
    return {
      status: 'not_accpeted'
    };
  },
  components: {
    json
  },
  mounted() {
    const _this = this;
    map = Highcharts.mapChart('map-container', {
      series: [
        {
          type: 'map',
          data: json,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '{point.name}',
            useHTML: true,
            style: {
              fontSize: '13px',
              fontFamily: 'Avenir, Helvetica, Arial, sans-serif'
            }
          },
          allowPointSelect: true,
          states: {
            hover: {
              color: '#ffe07d'
            },
            select: {
              color: 'orange'
            }
          },
          selected: true
        }
      ],
      plotOptions: {
        series: {
          point: {
            events: {
              unselect: function() {
                // prevents user from toggling regions
                return false;
              },
              click: function() {
                _this.$emit('region-select', this.name, this.id);
                _this.$emit('pic-select', this.name);
              }
            }
          }
        }
      },
      chart: {
        events: {
          load: function() {
            // select: _this.region
          }
        }
      },
      legend: { enabled: false },
      tooltip: { enabled: false },
      title: '',
      credits: { enabled: false }
    });

    if (typeof this.regionId == 'undefined') {
      this.regionId = 6; // Texas
    }

    map.get(this.regionId).select();
  },
  methods: {
    onSelectEntireUS() {
    }
  },
  beforeDestroy() {
    // map.get(this.regionId).select();
  }
};
</script>

<style lang="scss">
.modal-footer {
  button.btn {
    font-family: 'Avenir';
    font-weight: normal;
  }
}

#map-container {
  height: 300px;
  margin-left: -0.5rem;
}

h5.modal-title {
  // font-family: 'Courier New', Courier, monospace
  font-family: 'Avenir';
}
</style>
